import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton, Typography } from '@robinpowered/ui-kit';
import { useLocationDetailByIdQuery } from '../../../../generated/graphql';
/**
 * Shared presentational layer: apply logic + UI for a location and level.
 */
export var LocationLevel = function (_a) {
    var locationId = _a.locationId, levelId = _a.levelId;
    var t = useTranslation('meetingRooms').t;
    var _b = useLocationDetailByIdQuery({
        variables: {
            locationId: locationId,
        },
        skip: !locationId,
    }), locationData = _b.data, loading = _b.loading;
    var locationAndLevel = useMemo(function () {
        var _a, _b, _c, _d;
        if (!locationData)
            return null;
        return {
            location: (_a = locationData === null || locationData === void 0 ? void 0 : locationData.getLocationById) === null || _a === void 0 ? void 0 : _a.name,
            level: (_d = (_c = (_b = locationData === null || locationData === void 0 ? void 0 : locationData.getLocationById) === null || _b === void 0 ? void 0 : _b.levels) === null || _c === void 0 ? void 0 : _c.find(function (level) { return level.id === (levelId === null || levelId === void 0 ? void 0 : levelId.toString()); })) === null || _d === void 0 ? void 0 : _d.name,
        };
    }, [locationData, levelId]);
    if (loading)
        return (_jsx(Skeleton.Button, { size: "small", active: true, style: { width: '232px', height: '20px' } }));
    if (!locationAndLevel)
        return null;
    return (_jsx(Typography.Text, { type: "secondary", size: "small", children: t('eventDetails.formattedSpaceName.name', {
            spaceName: locationAndLevel === null || locationAndLevel === void 0 ? void 0 : locationAndLevel.level,
            locationName: locationAndLevel === null || locationAndLevel === void 0 ? void 0 : locationAndLevel.location,
        }) }));
};
